import { render } from "./dpp-photo.vue?vue&type=template&id=7ddedbd6"
import script from "./dpp-photo.js?vue&type=script&lang=js"
export * from "./dpp-photo.js?vue&type=script&lang=js"

import "./dpp-photo.vue?vue&type=style&index=0&id=7ddedbd6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__